import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { SVG } from "../../shared";
import { useGetSinglePrice } from "../../hooks/price";
import SinglePriceTable from "./components/SinglePriceTable";
import { SVG_ENUM } from "../../enums";
import "./PriceDetailsPage.scss";

const PriceDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, loading, error } = useGetSinglePrice(id);

  if (loading) {
    return (
      <div className="price-details-page">
        <div className="loading">Ładowanie szczegółów...</div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="price-details-page">
        <div className="page-header">
          <button
            className="back-button"
            onClick={() => navigate("/dashboard/prices")}
          >
            <SVG type={SVG_ENUM.BACK_CHEVRON} />
            Powrót do listy cen
          </button>
        </div>
        <div className="error">
          {error || "Nie znaleziono rekordu z podanym ID"}
        </div>
      </div>
    );
  }

  return (
    <div className="price-details-page">
      <div className="page-header">
        <div className="header-content">
          <button
            className="back-button"
            onClick={() => navigate("/dashboard/prices")}
          >
            <SVG type={SVG_ENUM.ARROW_LEFT} />
          </button>
          <h1>Aktualizacja z dnia {data.changeDate}</h1>
        </div>
      </div>

      <SinglePriceTable
        items={data.updatedProducts}
        userName={data.userName}
        changeDate={data.changeDate}
      />
    </div>
  );
};

export default PriceDetailsPage;
